angular.module('acme.view.application.importExport.jobExecution.controllers.importExportJobExecutionDeleteModalController', [
  'ui.router',
  'ui.bootstrap',
  'acme.common.directive.dataGrid',
  'acme.common.service.permissions',
  'acme.view.application.importExport.jobExecution.directives.importExportJobExecutionFileUpload',
  'acme.view.application.importExport.jobExecution.directives.importExportJobExecutionErrorGrid',
])
.controller('ImportExportJobExecutionDeleteModalController', ImportExportJobExecutionDeleteModalController);

/**
 * Controller responsible for showing the user the downloadable Outputs for a Export Job Execution
 * @class ImportExportJobExecutionDeleteModalController
 * @constructor
 * @return {ImportExportJobExecutionDeleteModalController} - Class instance
 */
function ImportExportJobExecutionDeleteModalController(
  $uibModalInstance,
  ImportJobExecutionsApiService,
  reportName,
  executionId)
{
  Object.assign(this, {
    $uibModalInstance: $uibModalInstance,
    ImportJobExecutionsApiService: ImportJobExecutionsApiService,
    reportName: reportName,
    executionId: executionId
  });

  // TODO: update ui-router to 0.3.0 to avoid calling this manually
  this.$onInit();
}

ImportExportJobExecutionDeleteModalController.prototype.$onInit = function() {
  this.vm = this._getVm(this);
};

ImportExportJobExecutionDeleteModalController.prototype._getVm = function (initialData) {
  var _data = initialData || {},
    errorMessage = _data.errorMessage || '',
    executionId = _data.executionId || '',
    reportName = _data.reportName || '';

  return {
    errorMessage: errorMessage,
    executionId: executionId,
    reportName: reportName
  };
};

ImportExportJobExecutionDeleteModalController.prototype.cancel = function () {
  this.$uibModalInstance.close();
};

ImportExportJobExecutionDeleteModalController.prototype.remove = function () {
  var self = this;

  this.ImportJobExecutionsApiService.remove(this.vm.executionId)
    .then(function () {
      self.$uibModalInstance.close(true);
    }, function () {
      self.vm.errorMessage = 'Unable to delete Job Execution, please try again, or try again later.';
    });
};

ImportExportJobExecutionDeleteModalController.$inject = [
  '$uibModalInstance',
  'ImportJobExecutionsApiService',
  'reportName',
  'executionId'
];
